import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useSubscribedProductsForTitle } from '../../../queries/ats/me/products/hooks';
import { getClosestProduct, humanizeExpirationDate } from '../../../queries/ats/me/products/utils';
import { Title } from '../../../queries/ats/titles/types/title';
import { Badge } from '../../Badge';
import css from './ats-asset.module.scss';

interface AtsTitleBadgeProps {
  title: Title;
}

const MotionBadge = motion(Badge);

export function AtsTitleBadge({ title }: AtsTitleBadgeProps) {
  const { data: products } = useSubscribedProductsForTitle(title.masterId);
  const { t } = useTranslation();

  if (products === undefined || products.length === 0) {
    return null;
  }

  const product = getClosestProduct(products);

  if (product === undefined) {
    return null;
  }

  const animation = {
    initial: { y: -100, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -100, opacity: 0 },
    transition: { tween: 1.25 },
  };

  if (product.type === 'rental') {
    return (
      <MotionBadge className={css.badge} text={humanizeExpirationDate(product.expiresAt)} type="dark" {...animation} />
    );
  }

  return <MotionBadge className={css.badge} text={t('bought')} type="bought" {...animation} />;
}
